import { z } from 'zod';

export const ZEmailBlocklistRequest = z.object({
  email: z.string().email(),
});
